import React from "react";
import { FormattedMessage } from "react-intl";
import { PageMetadata } from "../../model/metadata";
import Link from "../Link/Link";
import LanguageMenu from "./LanguageMenu";
import styles from "./MinorNav.module.scss";
import Text from "../Text/Text";

interface MinorNavProps {
  metadata: PageMetadata;
}

const MinorNav = ({ metadata }: MinorNavProps) => {
  return (
    <ul className={styles.subHeader}>
      <li>
        <LanguageMenu
          buttonClassName={styles.link}
          alternates={metadata.alternates}
        />
      </li>
      <li>
        <Link to="https://support.microbit.org" className={styles.link}>
          <Text variant="defaultLight" as="span">
            <FormattedMessage id="help-and-support" defaultMessage="Help & support" />
          </Text>
        </Link>
      </li>
      <li>
        <Link to="/get-started/user-guide/safety/" className={styles.link}>
          <Text variant="defaultLight" as="span">
            <FormattedMessage id="safety" defaultMessage="Safety" />
          </Text>
        </Link>
      </li>
    </ul>
  );
};

export default MinorNav;
